/**
 * Mapping champs imprimante pour le wiring parent du Cockpit.
 * Aligné sur la modale Commerçants (handleEditCommercant) — App Key write-only.
 */
export function buildImpressionDraftFromCommercant(commercant) {
  if (!commercant) {
    return {
      imprimanteActive: false,
      imprimanteNumeroSerie: '',
      imprimanteAppId: '',
      imprimanteAppKey: '',
      imprimerCommandeValidee: true,
      imprimerCommandeAcceptee: false,
    };
  }
  return {
    imprimanteActive: Boolean(
      commercant.imprimanteActive ?? commercant.has_printer
    ),
    imprimanteNumeroSerie:
      commercant.imprimanteNumeroSerie || commercant.printer_sn || '',
    imprimanteAppId:
      commercant.imprimanteAppId || commercant.printer_app_id || '',
    imprimanteAppKey: '',
    imprimerCommandeValidee:
      commercant.imprimerCommandeValidee ??
      commercant.print_when_validated_order ??
      true,
    imprimerCommandeAcceptee: Boolean(
      commercant.imprimerCommandeAcceptee ??
        commercant.print_when_accepted_order
    ),
  };
}

/** Payload updateCommercant — mêmes règles que la modale (App Key seulement si saisie). */
export function buildImpressionUpdatePayload(draft) {
  const updateData = {
    imprimanteActive: Boolean(draft?.imprimanteActive),
    imprimanteNumeroSerie: draft?.imprimanteNumeroSerie?.trim() || null,
    imprimanteAppId: draft?.imprimanteAppId?.trim() || null,
    imprimerCommandeValidee: draft?.imprimerCommandeValidee !== false,
    imprimerCommandeAcceptee: Boolean(draft?.imprimerCommandeAcceptee),
  };
  if (draft?.imprimanteAppKey?.trim()) {
    updateData.imprimanteAppKey = draft.imprimanteAppKey.trim();
  }
  return updateData;
}
